import React, { useEffect, useState } from "react";
import { useLocation, useNavigate , useParams} from "react-router-dom";
import { PlusCircleIcon, ArrowLeftIcon } from "@heroicons/react/24/outline";
import ServicesToolTable from "./tables/ServicesTooltable";
import AdminNewServiceSlideOver from "../slideovers/AdminNewServiceSlideOver";
import AdminDeleteProfessionsSlideOver from "../slideovers/AdminDeleteProfessionsSlideOver";

const ServicesToolPage = () => {
  const {profession_id} = useParams()
  const [newServicesSLideOver, setNewServicesSlideOver] = useState(false);
  const [deleteSlideOver, setDeleteSlideOver] = useState(false);
  const [editInputId, setEditInputId] = useState(null);
  const location = useLocation();
  const { profession } = location?.state ?? {};
  const navigate = useNavigate();

  const handleClose = () => {
    setNewServicesSlideOver(false);
  };
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleDeleteSlideOverClose = () => {
    setDeleteSlideOver(false);
  };

  const handleServicesTable = (type, data) => {
    switch (type) {
      case "edit":
        setEditInputId(data?.id);
        break;
      case "delete":
        setDeleteSlideOver(true);
        break;

      default:
        break;
    }
  };

  return (
    <div className="col-span-12">
      <div className="flex justify-between items-center mb-[14px] md:mb-0">
        <div className="flex items-center gap-[6px] xl:gap-[10px]">
          <div className="flex items-center gap-[10px]">
            <ArrowLeftIcon
              className="w-6 h-6 text-[#485868] cursor-pointer"
              onClick={handleGoBack}
            />
            <h3
              className="hidden md:block text-xl xl:text-2xl font-normal leading-[130%] text-[#485868] cursor-pointer"
              onClick={handleGoBack}
            >
              Profession
            </h3>
          </div>
          <span className="hidden md:block text-[#485868]">&#8226;</span>
          <h3 className="md:block text-xl xl:text-2xl font-normal leading-[130%] text-[#485868] cursor-pointer">
            {location?.state?.profession?.name}
          </h3>
          <span className="text-[#485868]">&#8226;</span>
          <h3 className="text-xl xl:text-2xl font-bold leading-[130%] text-customGray">
          {profession?.name == "Mental Health Counselor" ? "Specialties" :    "Services"}
          </h3>
        </div>
        <button
          className="w-12 h-12 flex justify-center items-center rounded-[10px] bg-primary cursor-pointer"
          onClick={() => setNewServicesSlideOver(true)}
        >
          <PlusCircleIcon className="w-6 h-6 text-white" />
        </button>
      </div>
      <ServicesToolTable
        professionId={profession_id}
        profession={profession}
        handleDropDownMenu={handleServicesTable}
        isEditId={editInputId}
        setEditInputId={setEditInputId}
      />
      <AdminNewServiceSlideOver
        show={newServicesSLideOver}
        setCourseSlideOver={setNewServicesSlideOver}
        handleClose={handleClose}
      />
      <AdminDeleteProfessionsSlideOver
        show={deleteSlideOver}
        setCourseSlideOver={setDeleteSlideOver}
        handleClose={handleDeleteSlideOverClose}
        text="service"
      />
    </div>
  );
};

export default ServicesToolPage;